
import * as authHelper from '../../app/modules/auth/core/AuthHelpers'
// import { AuthModel } from '../../app/modules/auth';
import { User } from '../../app/modules/apps/user-management/users-list/core/_models'
import { Response as oResponse } from '../../_metronic/helpers'
import { LanguageHelp, getConfig } from '../../_metronic/helpers/LanguageHelper'


export function getMonthName(monthNumber: number) {
  const date = new Date();
  date.setMonth(monthNumber - 1);
  const lang = getConfig()
  // Using the browser's default locale.
  return date.toLocaleString(lang.selectedLang, { month: 'long' });
}

// export function getTimeAgoFromDate(date: Date): string {
export function getTimeAgoFromDate(date: Date) {
  if (date === null) { return ""; }

  const difftime = new Date().getTime() - new Date(date).getDate();
  const diffDate = new Date(difftime - 5.5 * 60 * 60 * 1000);
  const [sec, min, hr, day, month] = [
    diffDate.getSeconds(),
    diffDate.getMinutes(),
    diffDate.getHours(),
    diffDate.getDate() - 1,
    diffDate.getMonth(),
  ];

  const f = (property: number, end: string) => {
    return `${property} ${end}${property > 1 ? "s" : ""} ago`;
  }
  return month >= 1
    ? f(month, "month")
    : day >= 1
      ? f(day, "day")
      : hr >= 1
        ? f(hr, "hr")
        : min >= 1
          ? f(min, "min")
          : day >= 1
            ? f(sec, "sec")
            : "";
}

export function formatDate(date: Date, locale: string) {
  return new Date(date).toLocaleString(locale, { dateStyle: 'short', timeStyle: 'short' })
}

export function getUserRole(role: number | undefined) {
  switch (role) {
    case 2: { return LanguageHelp("Agent"); }
    case 3: { return LanguageHelp("Admin"); }
    case 6: { return LanguageHelp("Account Owner"); }
    case 8: { return LanguageHelp("Reporter"); }
    default: { return LanguageHelp("Agent"); }
  }
}

export function getUserRoleEnum(role: string) {
  switch (role) {
    case "Agent": { return 2; }
    case "Admin": { return 3; }
    case "Account Owner": { return 6; }
    case "Reporter": { return 8; }
    default: { return 0; }
  }
}

export function convertUserToDashboardModel(agent: any) {
  let auth: any = authHelper.getAuth()
  var parsedAgent: User = {
    id: agent.id,
    name: agent.name + " " + agent.surname,
    avatar: agent.avatarUrl,
    email: agent.email,
    // position: "",
    role: getUserRole(agent.role),
    lastLogin: getTimeAgoFromDate(agent.lastLogoutDate),
    isOnline: false,
    joinedDay: formatDate(agent.lastLogoutDate, auth?.result.language),//10 Nov 2022, 9:23 pm
    online: true,
    initials: {
      label: "",
      state: ""
    },
  };

  return parsedAgent;
}

export function getQueryStringValues(queryString: string) {
  return new URLSearchParams(queryString);
  //const value = urlParams.get('code')
}

export function convertReviewToDashboardModel(agent: any) {
  let auth: any = authHelper.getAuth()
  var parsedAgent: User = {
    id: agent.id,
    name: agent.name + " " + agent.surname,
    avatar: agent.avatarUrl,
    email: agent.email,
    // position: "",
    role: getUserRole(agent.role),
    lastLogin: getTimeAgoFromDate(agent.lastLogoutDate),
    isOnline: false,
    joinedDay: formatDate(agent.lastLogoutDate, auth?.result.language),//10 Nov 2022, 9:23 pm
    online: true,
    initials: {
      label: "",
      state: ""
    },
  };

  return parsedAgent;
}

export function convertTokenToDashboardModel(agent: any) {
  let auth: any = authHelper.getAuth()
  var parsedAgent: User = {
    id: agent.id,
    name: agent.name + " " + agent.surname,
    avatar: agent.avatarUrl,
    email: agent.email,
    // position: "",
    role: getUserRole(agent.role),
    lastLogin: getTimeAgoFromDate(agent.lastLogoutDate),
    isOnline: false,
    joinedDay: formatDate(agent.lastLogoutDate, auth?.result.language),//10 Nov 2022, 9:23 pm
    online: true,
    initials: {
      label: "",
      state: ""
    },
  };

  return parsedAgent;
}

export function convertTimeAgo(timeContent: string | undefined) {
  timeContent = (timeContent as string)
    .replace('days ago', LanguageHelp('days ago'))
    .replace('hours ago', LanguageHelp('hours ago'))
    .replace('seconds ago', LanguageHelp('seconds ago'))

  return timeContent;
}

export class Select2Option {
  value = "";
  label = "";
  color = "";
  isFixed?: boolean;
  isDisabled?: boolean;
  // constructor() {
  // }
  constructor(value: string,label: string = "") {
    this.value = value.replaceAll("&", "asc38");
    this.label = label === "" ? value : label;
  }
}

export function combineSelect2Values(myArray: any[]) {
  return myArray === undefined ? "" : myArray.map(field => field.label).join(', ');
}

export function convertStringsSelect2Values(myArray: string[]) {
  return myArray.map(field => new Select2Option(field));
}

export function getHappinessScore(number1: number, number2: number) {// number1 is positive, number2 is negative

  var result = number1 / (number1 + number2);

  return Math.trunc(result * 100) / 100;
}

export function getColorCodeFromDivision(number1: number, number2: number) {// number1 is positive, number2 is negative

  var result = number1 / (number1 + number2);

  result = Math.round(result * 5);

  switch (result) {
    case 5: return "#47be7d";
    case 4: return "#47be7d";
    case 3: return "#ff9900";
    case 2: return "#ff9900";
    case 1: return "#f1416c";
    case 0: return "#f1416c";
    default: return "#ff9900";
  }
}

export function textOverflowWithEllipsis(string: string, endIndex: number = 15) {

  if (string.length > endIndex) {
    return string.substring(0, endIndex) + '...';
 }
 return string;
}